import React from "react";

import {
  MainContent,
  ContentStyled,
  TitleStyled,
  TextBoxStyled,
  ButtonStyled,
  ButtonText,
} from "./styles";

import ReturnIcon from "../../assets/return.png";
import LogoIcon from "../../assets/tulz-logo-old.png";

const MessagePage = ({ handleBack, onChangeText, onSubmit }) => {
  return (
    <MainContent>
      <span
        style={{
          top: 24,
          left: 24,
          position: "absolute",
          padding: 14,
          borderRadius: 100,
          borderStyle: "solid",
          borderWidth: 2,
          zIndex: 999,
        }}
        onClick={handleBack}
      >
        <img src={ReturnIcon} alt="voltar" />
      </span>
      <div>
        <ContentStyled
          style={{
            marginTop: "10%",
            marginBottom: 24,
          }}
        >
          <TitleStyled>
            Em poucas palavras, descreva o que motivou sua nota
          </TitleStyled>
        </ContentStyled>
        <ContentStyled>
          <TextBoxStyled
            multiline
            onChange={(e) => onChangeText(e.target.value)}
            placeholder="Digite aqui (Opcional)"
          ></TextBoxStyled>
          <ButtonStyled
            style={{
              backgroundColor: "#511C6D",
              padding: 12,
              width: 200,
              marginTop: 24,
            }}
            onClick={onSubmit}
          >
            <ButtonText>Enviar</ButtonText>
          </ButtonStyled>
        </ContentStyled>
        <ContentStyled style={{ marginTop: "10%" }}>
          <img src={LogoIcon} alt="Logo Tulz" />
        </ContentStyled>
      </div>
    </MainContent>
  );
};

export default MessagePage;
